<template>
    <i class="text-dark fas fa-chart-line" aria-hidden="true"></i>
</template>